<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="blue"
          title="Prospects"
          text="Prospects Salvos"
          v-if="!loading"
        >
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <template v-slot:loading>
            <v-progress-linear
              v-if="loading"
              height="2"
              color="cyan"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-data-table
            dense
            light
            :headers="headers"
            :items="leads"
            :loading="loading"
            :rows-per-page-items="[10, 25, 50, 100]"
            :pagination.sync="pagination"
            :search="search"
            item-key="email"
            rows-per-page-text="Linhas por página"
            no-data-text="Não há prospects salvos"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.saved_at | formatDate }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.sales_observation }}</td>
              <!-- <td>{{ item.status }}</td> -->
              <td class="justify-center">
                <v-icon class="mr-2" color="blue" @click="openMyDialog(item)">
                  edit
                </v-icon>
                <v-icon color="red" @click="deleteItem(item.id)">
                  delete
                </v-icon>
              </td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning"
                >Sua busca para "{{ search }}" não retornou resultados.</v-alert
              >
            </template>
            <template v-slot:pageText="items">
              Linhas {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }}
            </template>
          </v-data-table>
        </material-card>
        <cpnCreateCustomer />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from "moment";
import firestore from "../../firebase/firestore";
import { eventBus } from "../../main";
import CreateCustomer from "../../components/sales/CreateCustomer";
import { mapState } from "vuex";

export default {
  components: {
    cpnCreateCustomer: CreateCustomer,
  },
  created() {
    if (this.user.id) {
      this.loading = true;
      firestore
        .collection("leads")
        .where("saved_partner", "==", this.user.email)
        .where("status", "==", "SAVED")
        .orderBy("saved_at", "desc")
        .onSnapshot({ includeMetadataChanges: true }, async (res) => {
          const changes = res.docChanges();
          // eslint-disable-next-line no-unused-vars
          for (const [idx, change] of changes.entries()) {
            const { newIndex, oldIndex, doc, type } = change;
            if (change.type === "added") {
              let new_doc = {
                ...doc.data(),
                id: doc.id,
              };
              this.leads.splice(newIndex, 0, new_doc);
            } else if (change.type === "modified") {
              // remove the old one first
              this.leads.splice(oldIndex, 1);
              // if we want to handle references we would have to unsubscribe
              // from old references' listeners and subscribe to the new ones
              if (doc.data().status !== "SAVED") {
                let new_doc = {
                  ...doc.data(),
                  id: doc.id,
                };
                this.leads.splice(newIndex, 0, new_doc);
              }
            } else if (type === "removed") {
              this.leads.splice(oldIndex, 1);
            }
          }
          this.loading = false;
        });
    }
  },
  data: () => ({
    leads: [],
    pagination: {
      rowsPerPage: 200, // -1 for All",
    },
    search: "",
    loading: false,
    headers: [
      {
        sortable: true,
        text: "Salvo em",
        value: "saved_at",
      },
      {
        sortable: true,
        text: "email",
        value: "email",
      },
      {
        sortable: true,
        text: "Name",
        value: "name",
      },
      {
        text: "Observação",
        value: "sales_observation",
      },
      {
        text: "",
        value: "",
      },
    ],
  }),
  computed: {
    ...mapState(["user"]),
  },
  filters: {
    formatDate(value) {
      if (!value) return "";
      let d = moment(value.toDate()).format("DD/MM/YYYY HH:mm");
      // console.log(d)
      return d;
    },
  },
  methods: {
    async openMyDialog(lead) {
      this.loading = true;
      // console.log('lead1: ', newLead)
      eventBus.$emit("Lead", lead);
      this.loading = false;
      eventBus.$emit("dialog", true); // emit the event to the bus
    },
    async deleteItem(lead) {
      let valid = confirm("Tem certeza que deseja excluir esse item?");
      if (valid) {
        // this.loading = true
        const data = {
          status: "LEAD",
        };
        firestore
          .collection("leads")
          .doc(lead)
          .update(data)
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            console.error(err);
            alert("Erro ao tentar retirar item da lista de prospects. " + err);
            this.loading = false;
          });
      }
    },
  },
};
</script>
